export default __webpack_public_path__ + "static/media/fresnelWebsite@2x.89243de4.jpg";